export const CREATE_MERCHANT = "CREATE_MERCHANT";
export const MERCHANTS_RECEIVED = "MERCHANTS_RECEIVED";
export const SET_PROPERTY_MERCHANT = "SET_PROPERTY_MERCHANT";
export const SINGLE_MERCHANT_RECEIVED = "SINGLE_MERCHANT_RECEIVED";
